import React, { createContext} from "react";

  const RegistrationStatus = React.createContext();
  export default RegistrationStatus;